import React from 'react';
import AnalyticsManager from 'ia-react-core/~/services/analytics/AnalyticsManager';

interface AnalyticsContextProps {
  scope: string[];
  values: object;
  pageValues: Map<object, object>;
  analytics?: AnalyticsManager;
}

const AnalyticsContext = React.createContext<AnalyticsContextProps>({ scope: [], values: {}, pageValues: new Map() });

export default AnalyticsContext;
